import clsx from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  /** 패딩 없는 컨테이너(테이블·리스트 래퍼용). */
  flush?: boolean;
}

/** 표준 카드 — 흰 표면 + 옅은 보더 + 라운드. (Phase 0 stub) */
export function Card({ children, flush, className, ...rest }: CardProps) {
  return (
    <div
      className={clsx(
        'bg-surface border border-border-subtle rounded-lg shadow-1',
        !flush && 'p-4',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
